<template>
  <div class="pt-3 min-h-screen">
    <!-- <pre>{{ course_list }}</pre> -->
    <!-- <pre> {{ inscription }}</pre> -->
    <div class="columns">
      <!-- Sidebar de cursos -->
      <div class="column is-4">
        <!-- <h2 class="title is-5 mb-3">{{ $t("my courses") }}</h2> -->
        <label class="label"> {{ $t("course filter") }}</label>
        <input
          class="input mb-4"
          type="text"
          :placeholder="$t('course filter')"
          v-model="searchQuery"
        />
        <aside class="menu">
          <ul class="menu-list">
            <li v-for="(course, cidx) in filteredCourses" :key="cidx">
              <a
                :class="{
                  'is-active':
                    selectedCourse && selectedCourse.id === course.id,
                }"
                @click="selectCourse(course)"
              >
                <div class="title is-6">
                  <span class="icon">
                    <i class="fa fa-book"></i>
                  </span>
                  <span class="ml-1">{{ course.course_name }}</span>
                </div>
                <div class="subtitle is-6">
                  <span class="icon">
                    <i class="fa fa-user"></i>
                  </span>
                  <span class="ml-1"
                    >{{ course.professor_name }} -
                    {{ course.section_name }}</span
                  >
                </div>
              </a>
            </li>
          </ul>
        </aside>
      </div>

      <!-- Detalle del curso seleccionado -->
      <div class="column">
        <div v-if="classroom">
          <div class="title is-4">
            <span>{{ classroom.course.name }}</span>
          </div>

          <div class="subtitle is-5 mb-0">
            {{ classroom.professor.first_name }}
            {{ classroom.professor.first_surname }} -
            {{ classroom.period.name }}
          </div>
          <div class="columns">
            <div class="column">
              <span class="icon">
                <i class="fa fa-globe"></i>
              </span>
              <span
                class="is-size-6"
                v-if="
                  classroom &&
                  classroom.settings &&
                  classroom.settings.virtual_classroom_url
                "
              >
                <a
                  target="_blank"
                  :href="classroom.settings.virtual_classroom_url"
                  >{{ classroom.settings.virtual_classroom_url }}</a
                >
              </span>
              <span class="is-size-6 has-text-warning" v-else>{{
                $t("no virtual classroom set yet")
              }}</span>
            </div>
            <!-- <div class="column"></div> -->
          </div>

          <!-- <pre>{{ classroom.settings }}</pre> -->

          <div v-if="classroom.settings && classroom.settings.stages">
            <div class="tabs is-toggle is-fullwidth" ref="tabs">
              <ul>
                <li
                  data-tab="stage_general"
                  @click="change_active_tab($event, this)"
                >
                  <a>
                    <i class="info icon" aria-hidden="true"></i>
                    <span>{{ $t("general") }}</span>
                  </a>
                </li>
                <li
                  :data-tab="'stage_' + sidx"
                  @click="change_active_tab($event, this)"
                  v-for="(stage, sidx) in classroom.settings.stages || []"
                  :key="sidx"
                >
                  <a>
                    <i class="book icon" aria-hidden="true"></i>
                    <span>{{ stage.name }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="is-fluid" ref="contents">
              <div class="is-hidden" data-tab="stage_general">
                <div
                  v-if="
                    classroom &&
                    classroom.student_list &&
                    classroom.student_list.length
                  "
                >
                  <div
                    class="columns is-multiline"
                    v-for="(student, iidx) in classroom.student_list"
                    :key="iidx"
                  >
                    <div
                      class="column is-4"
                      v-for="(stage, sidx) in student.stages || []"
                      :key="sidx"
                    >
                      <div class="card">
                        <header class="card-header">
                          <p class="card-header-title">
                            <span class="icon">
                              <i class="fa fa-book"></i>
                            </span>
                            <span class="">
                              {{ stage.name }}
                            </span>
                          </p>
                        </header>
                        <div class="card-content">
                          <div class="content">
                            <div class="subtitle is-6 mb-0">
                              <span class="icon">
                                <i class="fa fa-clock-o"></i>
                              </span>
                              <span class="">{{ stage.score }}</span>
                            </div>
                            <div class="subtitle is-6">
                              <span class="icon">
                                <i class="fa fa-graduation-cap"></i>
                              </span>
                              <span class="">{{ stage.score }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="is-hidden"
                :data-tab="'stage_' + sidx"
                v-for="(stage, sidx) in classroom.settings.stages || []"
                :key="sidx"
              >
                <div
                  v-if="
                    classroom &&
                    classroom.student_list &&
                    classroom.student_list.length
                  "
                >
                  <div
                    v-for="(student, iidx) in classroom.student_list"
                    :key="iidx"
                  >
                    <div class="columns is-multiline">
                      <div
                        class="column is-4"
                        v-for="(activity, aidx) in student.stages.find(
                          (s) => s.id == stage.id
                        )?.activities || []"
                        :key="aidx"
                      >
                        <div class="card">
                          <header class="card-header">
                            <p class="card-header-title">
                              <span class="icon">
                                <i class="fa fa-book"></i>
                              </span>
                              <span class="">
                                {{ activity.name }}
                              </span>
                            </p>
                          </header>
                          <div class="card-content">
                            <div class="content">
                              <div class="subtitle is-6 mb-0">
                                <span class="icon">
                                  <i class="fa fa-clock-o"></i>
                                </span>
                                <span class="">{{ activity.score }}</span>
                              </div>
                              <div class="subtitle is-6">
                                <span class="icon">
                                  <i class="fa fa-graduation-cap"></i>
                                </span>
                                <span class="">{{ activity.score }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <article class="message is-warning">
              <div class="message-body">
                {{ $t("no stages set yet") }}
              </div>
            </article>
          </div>
        </div>
        <!-- <pre>{{ classroom }}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import { get, error_message, change_active_tab } from "@/utils";
export default {
  name: "StudentCoursesDashboard",
  data() {
    return {
      inscription: null,
      classroom: null,
      searchQuery: "",
      selectedCourse: null,
    };
  },
  computed: {
    course_list() {
      let v = this;
      if (v.inscription) {
        let l = v.inscription.student_section_details.reduce((acc, item) => {
          if (item.section && item.section.student_classroom_sections) {
            item.section.student_classroom_sections.forEach((classroom) => {
              if (classroom.classroom.course) {
                acc.push({
                  section_name: item.section.name,
                  course_name: classroom.classroom.course.name,
                  professor_name: `${classroom.classroom.professor.first_name} ${classroom.classroom.professor.first_surname}`,
                  classroom_uuid: classroom.classroom.uuid,
                });
              }
            });
          }
          return acc;
        }, []);
        // console.log("l", l);
        return l;
      } else return [];
    },
    filteredCourses() {
      return this.course_list.filter(
        (course) =>
          course.section_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          course.course_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          course.professor_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
      );
    },
    totalTasks() {
      return this.selectedCourse ? this.selectedCourse.tasks.length : 0;
    },
    completedTasks() {
      return this.selectedCourse
        ? this.selectedCourse.tasks.filter((task) => task.completed).length
        : 0;
    },
    progressPercentage() {
      return this.totalTasks > 0
        ? ((this.completedTasks / this.totalTasks) * 100).toFixed(0)
        : 0;
    },
    upcomingTasks() {
      return this.selectedCourse
        ? this.selectedCourse.tasks.filter((task) => !task.completed)
        : [];
    },
  },
  methods: {
    change_active_tab,
    selectCourse(course) {
      // console.log("selected course", course);
      // this.selectedCourse = course;
      let v = this;
      v.$root.loader(true);
      get("/student-portal/student/classroom", { uuid: course.classroom_uuid })
        .then((response) => {
          v.classroom = response;
          setTimeout(() => {
            let elmnt = window.jQuery("[data-tab='stage_general']");
            if (elmnt) elmnt.click();
          }, 300);
        })
        .catch((error) => {
          console.log("error", error);
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_inscription(inscription) {
      let v = this;
      v.$root.loader(true);
      get("/student-portal/student/inscription", {
        uuid: inscription.uuid,
      })
        .then((response) => {
          v.inscription = response;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.is-active {
  font-weight: bold;
  color: #3273dc; /* Color primario de Bulma */
}
.min-h-screen {
  min-height: 100vh;
}
</style>
